import React from 'react';
import Box from '@material-ui/core/Box';
import MenuDialog from "../components/MenuDialog";
import Card from '@material-ui/core/Card';
import Typography from '@material-ui/core/Typography';
import AssetGridCircles from '../components/AssetGridCircles';
import { makeStyles } from '@material-ui/core/styles';
import Button from '@material-ui/core/Button';
import Grid from '@material-ui/core/Grid';
import TouchAppIcon from '@material-ui/icons/TouchApp';
import Avatar from '@material-ui/core/Avatar';

const useStyles = makeStyles({
    actionGrid: {
        border: '1px dashed rgba(0, 0, 0, 0.12)',
        backgroundColor: '#ff9c61',
        textAlign: 'center',
        padding: '6px 10px',
        whiteSpace: 'nowrap',
        minHeight: '70px',
        minWidth: '100px',
    },
    cardRow: {
        display: 'flex',
        alignItems: 'center',
        width: '100%',
        flexWrap: 'wrap'
    },
    labelCol: {
        display: 'flex',
        alignItems: 'center',
        flexShrink: 0,
        width: '160px'
    },
    circlesCol: {
        display: 'flex',
        alignItems: 'center',
        flex: 1,
        flexWrap: 'wrap',
        marginLeft: '30px',
        minWidth: 0
    },
    buttonCol: {
        display: 'flex',
        alignItems: 'center',
        marginLeft: 'auto',
        flexShrink: 0,
        paddingLeft: '8px'
    },
    card: {
        padding: '8px 12px',
        border: '1px solid rgba(0, 0, 0, 1)'
    },
    root: {
        width: '36px',
        height: '36px',
        marginLeft: '8px',
        flexShrink: 0
    },
});

const imageList = ['/images/unavailable.jpg',  '/images/off.png', '/images/stethoscope.jpg', '/images/mc.png', '/images/period.jpg',  '/images/toilet.png', '/images/meal.png' ];

export default function TopFields(props) {
    const classes = useStyles();
    const [menuItem, setMenuitem] = React.useState("");
    const [open, setOpen] = React.useState(false);

    function handleChange(evt) {
        evt.preventDefault();
        setMenuitem(evt.currentTarget.value);
        setOpen(true);
    };

    const content = props.menuList.map((key) =>
        <Grid key={props.menuList.indexOf(key)} item xs={12} sm={12}>
            <Card key={props.menuList.indexOf(key)} className={classes.card}>
                <div className={classes.cardRow}>
                    <div className={classes.labelCol}>
                        <Typography align="left" variant="h4" style={{ lineHeight: '44px', fontSize: '1.8rem' }}>{key}</Typography>
                        <Avatar src={imageList[props.menuList.indexOf(key)]} className={classes.root} />
                    </div>
                    {props.assetList.length > 0 &&
                        <div className={classes.circlesCol}>
                            <AssetGridCircles
                                override={false}
                                assetList={props.assetList.filter(it => key === it.tracking)}
                                tracking={key}
                                selectedAsset={props.selectedAsset}
                                setSelectedAsset={props.setSelectedAsset}
                            />
                        </div>
                    }
                    <div className={classes.buttonCol}>
                        <Button
                            value={key}
                            id={key}
                            className={classes.actionGrid}
                            onClick={handleChange}
                        >
                            <TouchAppIcon color="disabled" />
                            <Typography color="textSecondary" variant="body2">Tap</Typography>
                        </Button>
                    </div>
                </div>
            </Card>
        </Grid>
    );

    return (
        <Box pt={3}>
            <MenuDialog
                open={open && menuItem !== "" && props.selectedAsset !== ""}
                onClose={setOpen}
                updateTracking={props.updateTracking}
                setSelectedAsset={props.setSelectedAsset}
                createTransaction={props.createTransaction}
                createTransactionDate={props.createTransactionDate}
                selectedAsset={props.selectedAsset !== "" && props.selectedAsset}
                assetId={props.selectedAsset !== "" && props.assetList[props.selectedAsset].assetId}
                assetName={props.selectedAsset !== "" && props.assetList[props.selectedAsset].assetName}
                tracking={menuItem}
                content={props.selectedAsset !== "" && (props.assetList[props.selectedAsset].assetName + " has chosen to go " + menuItem + ".")}
            />
            <Grid container spacing={1}>
                {content}
            </Grid>
        </Box>
    );
}
